import { monitorValue } from "../../util/monitorUtils";
import { TIPO_TREM_FALLBACK, getDoorNumbers } from "../../util/doorLayout";

const buildDoorMatrixData = (monitor, tipoTrem = TIPO_TREM_FALLBACK) => {

    const matrix = {};

    const isActive = key =>
        monitorValue(
            monitor,
            key,
            0
        ) !== 0;

    // Mesma numeração usada pra exibir o número da porta (util/doorLayout.js)
    // — o grid de status precisa acompanhar exatamente os mesmos números,
    // senão a coluna pintada não bate com o número mostrado.
    const topDoors = car => getDoorNumbers(car, tipoTrem).top;

    const bottomDoors = car => getDoorNumbers(car, tipoTrem).bottom;

    const topConfig = [
        ["isolada", 0],
        ["condenada", 4],
        ["falha", 8],
        ["aberta", 12],
        ["fechadaTrava", 16]
    ];

    const bottomConfig = [
        ["fechadaTrava", 0],
        ["aberta", 4],
        ["falha", 8],
        ["condenada", 12],
        ["isolada", 16]
    ];

    for (let car = 1; car <= 8; car++) {

        const top = [];
        const bottom = [];

        const topCategory = {};
        const bottomCategory = {};

        topDoors(car).forEach((door, column) => {

            topConfig.forEach(([state, offset]) => {

                const key =
                    `carro${car}${state}${door}`;

                if (isActive(key)) {

                    const index =
                        column + offset;

                    top.push(index);

                    topCategory[index] =
                        monitor?.[key]?.category;
                }
            });
        });

        bottomDoors(car).forEach((door, column) => {

            bottomConfig.forEach(([state, offset]) => {

                const key =
                    `carro${car}${state}${door}`;

                if (isActive(key)) {

                    const index =
                        column + offset;

                    bottom.push(index);

                    bottomCategory[index] =
                        monitor?.[key]?.category;
                }
            });
        });

        matrix[car] = {

            disjuntorAberto:
                isActive(
                    `disjuntorAberto${car}`
                ),

            disjuntorAbertoCategory:
                monitor?.[
                    `disjuntorAberto${car}`
                ]?.category,

            portas: Array.from(
                { length: 8 },
                (_, i) =>
                    isActive(
                        `porta${i + 1}Carro${car}`
                    )
            ),

            top,
            bottom,

            topCategory,
            bottomCategory
        };
    }

    return matrix;
};

export default buildDoorMatrixData;
